'use client';

import { c as _c } from "react/compiler-runtime";
import type { UserResponse } from 'src/api/responses';
import type React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import useTranslations from 'src/hooks/useTranslations';

// import {
//   isConfiguration,
// } from '@effektify/types/guards';
const RowWrapper = styled(FlexRow)(({
  theme
}) => ({
  padding: theme.sizes.spacing.none,
  alignItems: 'center',
  gap: theme.sizes.spacing['03'],
  alignSelf: 'stretch',
  justifyContent: 'space-between'
}));
const TextWrapper = styled(FlexColumn)(({
  theme
}) => ({
  alignItems: 'flex-start',
  gap: theme.sizes.spacing['02'],
  padding: theme.sizes.spacing.none
}));
const Subheader = styled(Typography)(({
  theme
}) => ({
  color: theme.colors.text.tertiary
})) as typeof Typography;
interface HeaderWithFormProps {
  profile: UserResponse;
  children?: React.ReactNode;
  reportName: string;
}
const HeaderWithForm: React.FC<HeaderWithFormProps> = t0 => {
  const $ = _c(13);
  const {
    profile,
    children,
    reportName
  } = t0;
  const {
    t
  } = useTranslations();
  let t1;
  if ($[0] !== profile.name || $[1] !== t) {
    t1 = t("reportPage.welcomeUser", {
      name: profile.name
    });
    $[0] = profile.name;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Subheader variant="body1" component="span">{t1}</Subheader>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== reportName) {
    t3 = <Typography variant="heading-3xl" component="span">{reportName}</Typography>;
    $[5] = reportName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <TextWrapper>{t2}{t3}</TextWrapper>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = children || null;
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <RowWrapper>{t4}{t5}</RowWrapper>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default HeaderWithForm;